import React, { useState } from 'react';
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from './ui/dropdown-menu';
import { Button } from './ui/button';
import { Badge } from './ui/badge';
import { Languages } from 'lucide-react';
import { useLanguageStore } from '../stores/useLanguageStore';
import { cn } from '../lib/utils';

interface LanguageOption {
  locale: string;
  name: string;
  flag: string;
}

const languages: LanguageOption[] = [
  { locale: 'en', name: 'English', flag: '🇺🇸' },
  { locale: 'vi', name: 'Tiếng Việt', flag: '🇻🇳' },
];

export const ModernLanguageSwitcher = () => {
  const { locale, setLocale } = useLanguageStore();

  const handleLanguageChange = (newLocale: string) => {
    try {
      // Only change if it's different from current locale
      if (newLocale !== locale) {
        // Update the language in Zustand store
        setLocale(newLocale);
        // Reload the page to apply the language change
        window.location.reload();
      }
    } catch (error) {
      console.error('Failed to change language:', error);
    }
  };

  const currentLanguage =
    languages.find((lang) => lang.locale === locale) || languages[0];

  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <Button variant="ghost" size="icon" className="gap-1">
          <Languages className="h-5 w-5" />
          <span className="text-xs font-medium hidden sm:inline">
            {currentLanguage.locale === 'en' ? 'EN' : 'VI'}
          </span>
        </Button>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="end" className="min-w-[180px]">
        {languages.map((language) => (
          <DropdownMenuItem
            key={language.locale}
            onClick={() => handleLanguageChange(language.locale)}
            className={cn(
              'flex items-center gap-2',
              locale === language.locale && 'bg-accent'
            )}
          >
            <span className="text-xl">{language.flag}</span>
            <span className="flex-1">{language.name}</span>
            {locale === language.locale && (
              <Badge variant="outline" className="h-5 w-5 p-0 flex items-center justify-center">
                ✓
              </Badge>
            )}
          </DropdownMenuItem>
        ))}
      </DropdownMenuContent>
    </DropdownMenu>
  );
};
